// Imports
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs';

// UI Imports
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Button from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { 
  Grid, 
  Card, 
  CardMedia, 
  CardActions, 
  CardContent, 
  FormControlLabel, 
  IconButton, 
  ToggleButtonGroup, 
  ToggleButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  Paper,
} from "@mui/material";
import ViewListIcon from '@mui/icons-material/ViewList';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Tooltip from '@material-ui/core/Tooltip'
import Checkbox from "@mui/material/Checkbox"
import Box from '@mui/material/Box';
import { withStyles } from '@material-ui/core'
import styles from './styles'

// App Imports
import { messageShow } from '../../common/api/actions'
import SectionPaper from '../../common/SectionPaper'
import BrandedLoading from '../../common/BrandedLoading'
import EmptyMessage from '../../common/EmptyMessage'
import Image from '../../common/Image'
import { list, getCategories, listByCategory } from '../api/actions/query'
import { deleteCategory,remove, publishToggle, createOrUpdateCategory } from '../api/actions/mutation'
import routes, { getImageSource } from '../api/routes'
import { detail } from "../../setting/api/actions/query"
import { checkPermission } from "../../common/Sidebar/checkPermission";

// Component
class MediaGalleryList extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      categories: [],
      selectedCategory: null,
      filteredMediaList: [],
      permissions: {
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      }
    }
  }

  componentDidMount() {
    this.verifyPermissions();
    this.loadCategories();
  }
  
  // Update loadCategories method to use localStorage
loadCategories = async () => {
  try {
    const { data } = await getCategories();
    if (data.success) {
      const categories = data.data || [];
      this.setState({ categories });
      
      // Try to get last selected category from localStorage
      const lastSelectedCategory = localStorage.getItem('selectedMediaCategory');
      const categoryExists = categories.find(cat => cat._id === lastSelectedCategory);
      
      if (lastSelectedCategory && categoryExists) {
        // Use last selected category if it exists
        this.onCategorySelect(lastSelectedCategory);
      } else if (!this.state.selectedCategory && categories.length > 0) {
        // Fallback to first category only if no stored category and none selected
        this.onCategorySelect(categories[0]._id);
      }
    }
  } catch (error) {
    console.error("Error loading categories:", error);
  }
}

// Update onCategorySelect method to save to localStorage
onCategorySelect = async (categoryId) => {
  this.setState({ selectedCategory: categoryId });
  
  // Save selected category to localStorage
  if (categoryId) {
    localStorage.setItem('selectedMediaCategory', categoryId);
  } else {
    localStorage.removeItem('selectedMediaCategory');
  }
  
  try {
    const { data } = await listByCategory({ mediaGalleryCategoryId: categoryId });
    if (data.success) {
      this.setState({ filteredMediaList: data.data || [] });
    }
  } catch (error) {
    console.error("Error loading media by category:", error);
    this.setState({ filteredMediaList: [] });
  }
}

  verifyPermissions = async () => {
    const modulePermissions = await checkPermission("marketing", "mediaGallery");
    this.setState({
      permissions: {
        canView: modulePermissions.canView,
        canCreate: modulePermissions.canCreate,
        canEdit: modulePermissions.canEdit,
        canDelete: modulePermissions.canDelete
      }
    });
  }

  
  

  onPublishToggle = mediaGalleryId => async event => {
    const isPublished = event.target.checked

    let check = window.confirm(`Are you sure you want to ${isPublished ? 'publish' : 'unpublish'} this media item?`)

    if (check) {
      const { publishToggle, messageShow } = this.props

      try {
        const { data } = await publishToggle({ mediaGalleryId, isPublished })
        messageShow(data.message)

        if (data.success) {
          // Refresh current category view
          this.onCategorySelect(this.state.selectedCategory);
        }
      } catch (error) {
        messageShow('Some error occurred. Please try again.')
      }
    }
  }
  // Add this method to your MediaGalleryList component

onDelete = (mediaGalleryId) => () => {
  const { messageShow, remove } = this.props;
  
  // Check if remove function exists
  if (!remove) {
    console.error('remove function not available in props');
    messageShow('Delete function not available. Please refresh the page.');
    return;
  }
  
  const confirmDelete = window.confirm('Are you sure you want to delete this media item?');
  if (!confirmDelete) return;

  this.setState({ isLoading: true });

  // Use the 'remove' prop function that's already connected
  remove({ mediaGalleryId })
    .then(response => {
      console.log('Delete media response:', response);
      const { data } = response;
      
      if (data && data.success !== false) {
        messageShow(data.message || 'Media item deleted successfully');
        
        // Refresh the current category view
        if (this.state.selectedCategory) {
          this.onCategorySelect(this.state.selectedCategory);
        }
      } else {
        const errorMessage = data?.message || 'Failed to delete media item';
        messageShow(errorMessage);
        console.error('Delete media failed:', data);
      }
    })
    .catch(error => {
      console.error('Delete media error:', error);
      const errorMessage = error?.response?.data?.message 
        || error?.message 
        || 'An error occurred while deleting the media item';
      messageShow(errorMessage);
    })
    .finally(() => {
      this.setState({ isLoading: false });
    });
};

// Alternative method if you prefer to use a different naming convention
onDeleteMedia = (mediaGalleryId) => () => {
  const { messageShow, remove } = this.props;
  
  const confirmDelete = window.confirm('Are you sure you want to delete this media item?');
  if (!confirmDelete) return;

  remove({ mediaGalleryId })
    .then(response => {
      const { data } = response;
      messageShow(data.message || 'Media item deleted successfully');
      
      // Refresh current view
      if (this.state.selectedCategory) {
        this.onCategorySelect(this.state.selectedCategory);
      }
    })
    .catch(error => {
      console.error('Delete error:', error);
      messageShow('Failed to delete media item');
    });
};
  onDeleteCategory = (categoryId) => () => {
  const { messageShow } = this.props;
  
  // Show confirmation dialog
  const confirmDelete = window.confirm('Are you sure you want to delete this category?');
  
  if (!confirmDelete) {
    return;
  }

  this.setState({ isLoading: true });

  // Call the delete API
  this.props.deleteCategory({ _id: categoryId })
    .then(response => {
      console.log('Delete response:', response); // Debug log
      
      // Handle response structure
      const { data } = response;
      
      if (data && data.success !== false) {
        // Success case
        messageShow(data.message || 'Category deleted successfully');
        
        // Refresh categories list
        this.loadCategories();
        
        // If deleted category was selected, reset selection
        if (this.state.selectedCategory === categoryId) {
          this.setState({ 
            selectedCategory: null 
          });
          // Reload media gallery list without category filter
          this.onCategorySelect(null);
        }
      } else {
        // Error case
        const errorMessage = data?.message || 'Failed to delete category';
        messageShow(errorMessage);
        console.error('Delete category failed:', data);
      }
    })
    .catch(error => {
      console.error('Delete category error:', error);
      
      // Safe error message extraction
      let errorMessage = 'An error occurred while deleting the category';
      
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error?.message) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      }
      
      messageShow(errorMessage);
    })
    .finally(() => {
      this.setState({ isLoading: false });
    });
};
onDeleteCategoryAsync = (categoryId) => async () => {
  const { messageShow, deleteCategory } = this.props;
  
  const confirmDelete = window.confirm('Are you sure you want to delete this category?');
  if (!confirmDelete) return;

  this.setState({ isLoading: true });

  try {
    const response = await deleteCategory({ _id: categoryId });
    const { data } = response;
    
    if (data && data.success !== false) {
      messageShow(data.message || 'Category deleted successfully');
      await this.loadCategories();
      
      if (this.state.selectedCategory === categoryId) {
        this.setState({ selectedCategory: null });
        this.onCategorySelect(null);
      }
    } else {
      throw new Error(data?.message || 'Failed to delete category');
    }
  } catch (error) {
    console.error('Delete category error:', error);
    
    const errorMessage = error?.response?.data?.message 
      || error?.message 
      || 'An error occurred while deleting the category';
    
    messageShow(errorMessage);
  } finally {
    this.setState({ isLoading: false });
  }
};
  // Update the renderCategoryList method in your MediaGalleryList component:
  // Updated renderCategoryList method for your React component
renderCategoryList = () => {
  const { categories, selectedCategory, permissions, isLoading } = this.state;

  return (
    <Paper elevation={1} style={{ height: 'fit-content' }}>
      <Box p={2}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">Categories</Typography>
          <Tooltip title="Add Category" arrow>
            {permissions.canCreate && !isLoading ? (
              <Link to={routes.mediaGalleryCategoryCreate.path}>
                <IconButton color="primary">
                  <AddIcon />
                </IconButton>
              </Link>
            ) : (
              <IconButton color="primary" disabled>
                <AddIcon />
              </IconButton>
            )}
          </Tooltip>
        </Box>
        
        <List dense>
          {categories.map((category) => (
            <ListItem
              key={category._id}
              button
              selected={selectedCategory === category._id}
              onClick={() => this.onCategorySelect(category._id)}
              disabled={isLoading || !permissions.canEdit}
              style={{
                // Apply opacity based on isPublished status
                opacity: category.isPublished ? 1 : 0.5,
                backgroundColor: selectedCategory === category._id ? 
                  (category.isPublished ? 'rgba(13, 53, 89, 0.12)' : 'rgba(13, 53, 89, 0.06)') : 
                  'transparent'
              }}
            >
              <ListItemText 
                primary={
                  <span style={{ 
                    color: category.isPublished ? 'inherit' : '#757575',
                    fontStyle: category.isPublished ? 'normal' : 'italic'
                  }}>
                    {category.name}
                    {!category.isPublished && ' (Unpublished)'}
                  </span>
                } 
                secondary={`${category.mediaCount || 0} items`}
                secondaryTypographyProps={{
                  style: { color: category.isPublished ? 'inherit' : '#9e9e9e' }
                }}
              />
              <ListItemSecondaryAction style={{ opacity: category.isPublished ? 1 : 0.7 }}>
                {/* Edit Icon */}
                <Tooltip title="Edit" arrow>
                  <span>
                    <IconButton
                      edge="end"
                      size="small"
                      component={Link}
                      to={routes.mediaGalleryCategoryEdit.path(category._id)}
                      onClick={(e) => e.stopPropagation()}
                      disabled={!permissions.canEdit || isLoading}
                      color="primary"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>

                {/* Delete Icon */}
                <Tooltip title="Delete" arrow>
                  <span>
                    <IconButton
                      edge="end"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.onDeleteCategory(category._id)();
                      }}
                      disabled={!permissions.canDelete || isLoading}
                      color="error"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Box>
    </Paper>
  );
}

  renderMediaGrid = () => {
    const { filteredMediaList, permissions } = this.state;
    const { classes } = this.props;

    return (
      <Grid container spacing={3}>
        {filteredMediaList.map(({ _id, mediaUrl, title, mediaType, sort, updatedAt, isPublished, modifiedBy }) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={_id}>
            <Card sx={{ maxWidth: 400, cursor: permissions.canEdit ? "pointer" : "default" }} 
                  onClick={() => permissions.canEdit && this.props.history.push(`/media-gallery/edit/${_id}`)}>
              <CardMedia
                component="img"
                image={getImageSource(mediaUrl)}
                onError={(e) => {
                  e.target.src = getImageSource();
                  e.target.style.maxHeight = '120px';
                }}
                style={{
                  objectFit: 'contain',
                  width: '100%'
                }}
              />
              <CardContent>
                <Typography variant="h6">{title}</Typography>
                <Typography variant="body2" color="textSecondary">{mediaType}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Updated: {dayjs(updatedAt).format('DD-MM-YYYY, hh:mm A')}
                  {modifiedBy?.name ? ` by ${modifiedBy.name}` : ''}
                </Typography>
              </CardContent>
              <CardActions>
                <Tooltip title="Delete" arrow>
                  <IconButton 
                    color="error" 
                    onClick={(e) => { 
                      e.stopPropagation(); 
                      this.onDelete(_id)(); 
                    }} 
                    disabled={!permissions.canDelete}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isPublished}
                      onClick={(e) => e.stopPropagation()}
                      onChange={this.onPublishToggle(_id)}
                      disabled={!permissions.canEdit}
                    />
                  }
                  label="Published"
                />
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  renderMediaTable = () => {
    const { filteredMediaList, permissions } = this.state;

    return (
      <SectionPaper>
        <Table padding={"normal"}>
          <TableHead>
            <TableRow>
              <TableCell width={85}>Image</TableCell>
              <TableCell width={150}>Title</TableCell>
              <TableCell width={120}>Media Type</TableCell>
              <TableCell width={80}>Sort</TableCell>
              <TableCell width={200}>Updated</TableCell>
              <TableCell width={80} align="center">Published</TableCell>
              <TableCell width={180} align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredMediaList.map(({ _id, mediaUrl, title, mediaType, sort, updatedAt, isPublished, modifiedBy }) =>
              <TableRow 
                key={_id} 
                disabled={!permissions.canView} 
                onClick={() => permissions.canEdit && this.props.history.push(`/media-gallery/edit/${_id}`)} 
                style={{ cursor: permissions.canEdit ? 'pointer' : 'default' }} 
                hover
              >
                <TableCell>
                  <Link to={routes.mediaGalleryEdit.path(_id)}>
                    <Image
                      src={getImageSource(`${mediaUrl}`)}
                      defaultSrc={getImageSource()}
                    />
                  </Link>
                </TableCell>
                <TableCell>{title}</TableCell>
                <TableCell>{mediaType}</TableCell>
                <TableCell>{sort || 0}</TableCell>
                <TableCell>
                  {dayjs(updatedAt).format('DD-MM-YYYY, hh:mm A')}
                  {modifiedBy?.name ? ` by ${modifiedBy.name}` : ''}
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    onClick={(e) => e.stopPropagation()}
                    checked={isPublished}
                    disabled={!permissions.canEdit}
                    onChange={this.onPublishToggle(_id)}
                    color="primary"
                  />
                </TableCell>
                <TableCell align="center">
                  <Tooltip title="Delete" arrow>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        this.onDelete(_id)();
                      }}
                      color="error"
                      disabled={!permissions.canDelete}
                    >
                      <DeleteIcon />
                    </Button>
                  </Tooltip>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </SectionPaper>
    );
  }

  // Render Helper Section
  renderHelper = () => {
    return (
      <Box sx={{ p: 3, pt: 2 }}>
        <Box 
          sx={{ 
            backgroundColor: '#F8F9FE', 
            borderRadius: '8px', 
            border: '1px solid #E9ECEF',
            p: 3
          }}
        >
          <Box display="flex" alignItems="center" mb={2} sx={{ color: '#0d3559' }}>
            <LightbulbOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
              MEDIA GALLERY QUICK TIPS
            </Typography>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#0d3559', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Categories:</span> Use the + icon to create new categories. Browse different sections by selecting a category from the left sidebar.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#0d3559', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Media Items:</span> Use the "Add Media" button to upload new content to the selected category.
                </Typography>
              </Box>
            </Grid>

             <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#0d3559', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Publishing:</span> Toggle the checkbox to publish/unpublish items. Unpublished items will not be visible on the live site.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    )
  }

  // Update the render method in MediaGalleryList component:
render() {
  const { mediaGallery: { isLoading }, classes } = this.props
  const { permissions, filteredMediaList, selectedCategory } = this.state;

  const selectedCategoryName = selectedCategory ? 
    this.state.categories.find(cat => cat._id === selectedCategory)?.name : 
    'MilestoneShowcase';

  return (
    <div>
      {/* Main Heading */}
      <Box sx={{ p: 3, pb: 1 }}>
        <Typography variant="h4" color="inherit" sx={{ fontWeight: 'bold', mb: 1 }}>
          Media Gallery
        </Typography>
        <hr style={{ 
          border: 'none', 
          borderTop: '2px solid #e0e0e0', 
          margin: '10px 0 20px 0' 
        }} />
      </Box>

      { isLoading ? (
        <BrandedLoading />
      ) : (
        <>
          <Box display="flex" gap={3} px={3}>
          {/* Left Sidebar - Categories */}
          <Box width={300} flexShrink={0}>
            {this.renderCategoryList()}
          </Box>

          {/* Right Content - Media Items */}
          <Box flexGrow={1}>
            {/* Add Media Button and View Toggle - Above Media Content */}
            <Box display="flex" justifyContent="flex-end" alignItems="center" >
              <Tooltip title="Add Media" arrow>
                {permissions.canCreate ? (
                  <Link to={
                    selectedCategory 
                      ? `${routes.mediaGalleryCreate.path}?categoryId=${selectedCategory}`
                      : routes.mediaGalleryCreate.path
                  }>
                    <Button
                      color="primary"
                      startIcon={<AddIcon />}
                      size="large"
                    >
                      Add Media
                    </Button>
                  </Link>
                ) : (
                  <Button
                    disabled
                    color="primary"
                    startIcon={<AddIcon />}
                    size="large"
                  >
                    Add Media
                  </Button>
                )}
              </Tooltip>
            </Box>

            {/* Media Content */}
            {filteredMediaList.length === 0 ? (
              <SectionPaper>
                <EmptyMessage message={
                  selectedCategory ? 
                  'No media items found in this category.' : 
                  'You have not added any media items yet.'
                } />
              </SectionPaper>
            ) : (
              this.renderMediaTable()
            )}
          </Box>
        </Box>
        {this.renderHelper()}
        </>
      )}
    </div>
  )
}
}

// Component Properties
MediaGalleryList.propTypes = {
  mediaGallery: PropTypes.object.isRequired,
  list: PropTypes.func.isRequired,
  publishToggle: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  createOrUpdateCategory: PropTypes.func.isRequired,
  deleteCategory: PropTypes.func.isRequired
}

// Component State
function listState(state) {
  return {
    mediaGallery: state.mediaGallery
  }
}

export default connect(listState, { list, publishToggle, remove, deleteCategory, createOrUpdateCategory, messageShow })(withStyles(styles)(MediaGalleryList))